import { createContext } from "react"
import { PresetPlace } from "Types/place"
import { PresetBoard } from "Types/board"
import { ArticleType } from "Types/article"
export interface WeekDay {
    text: string,
    day: number,
}

export interface PresetModal {
    show: boolean,
    text: string,
    type: "add" | "update",
    data: {
        weekDay: WeekDay,
        place: PresetPlace,
        preset?: PresetBoard,
    },
}

export const PresetContext = createContext<{
    weekDays: WeekDay[],
    sidePlaces: PresetPlace[],
    calendarData: {[key: string]: PresetBoard },
    presetModal: PresetModal | null,
    setPresetModal: (modalData: PresetModal | null) => void,
    articleTypes: ArticleType[],
    createPreset: any,
    updatePreset: any,
    deletePreset: any,
}>({
    weekDays: [],
    sidePlaces: [],
    calendarData: {},
    presetModal: null,
    setPresetModal: () => {},
    articleTypes: [],
    createPreset: null,
    updatePreset: null,
    deletePreset: null,
})

export default PresetContext.Provider
